/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Many/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Clear from './Clear/index'
import Dropdown from 'DesignSystem/Dropdown/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Many({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/DocumentTemplatesOld/Templates/LocationChooser/Content/Many"
  
}) {
let locationsValueData = fromData.useDataValue({ viewPath,
context: 'locations',
})
let selectedLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'location_id',
})
let onClick = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Many.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Many.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Dropdown
  viewPath={`${viewPath}/Dropdown`}
 data="locations"
 from={locationsValueData}
 data="selected.location_id"
 onClick={onClick}
 selected={selectedLocationIdValueData}
 label="Locations"
 maxWidth={310}
 width={310}
 height={300}
 top={34}
/>
<Clear
  viewPath={`${viewPath}/Clear`}
/>
</div>
</div>
{children}
</React.Fragment>)
}